<template>
  <div class="is-marginless is-paddingless section section-details" v-if="devis && detailDevis">
    <div class="pdt-20px">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detail.titleDevis') }} n°: {{ detailDevis.code }}</h1>
              <tag-list
                  class="mgb-0"
                  v-if="devisTags.length > 0"
                  :listes="devisTags"/>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <a ref="lienDownload"></a>
        <div class="level-right" v-if="canSeeDevis">
          <div class="buttons">

          <dropdownButton
            type="is-addOrEdit"
            class="mgr-2"
            :permission="permDevis.maj"
            v-if="activeButtonEtLien
              && (etatEnregistre || etatCommandePartiellement)"
            :actions="actionSecondary"
            @click="() => {
              $router.push({ name: 'm.bodac.devis', params: {id: $route.params.id}});
            }">
              {{ $t('detail.buttons.edit') }}
          </dropdownButton>

            <b-tooltip
              :active="disableButtonCommande || hasProspect"
              position="is-left"
              :label="hasProspect ? $t('detailDevis.infoButtonDesactiverCommandeCarPropect')
                : $t('detailDevis.infoButtonDesactiverCommande')"
              class="mgr-2">
              <button v-if="hasProspect"
                class="button button-access-no-permission disabledButton">
                {{ $t('detail.buttons.commander') }}
              </button>

              <dropdownButton
                type="is-addOrEdit"
                v-else-if="etatEnregistre && activeButtonEtLien"
                class="mgr-2"
                :permission="permCommandes.maj"
                :actions="actionSecondaryCommande"
                :disabled="disableButtonCommande"
                @click="isCommandeOpen = true">
                  {{ $t('detail.buttons.commander') }}
              </dropdownButton>

              <dropdownButton
                type="is-addOrEdit"
                v-else-if="etatCommandePartiellement && activeButtonEtLien"
                class="mgr-2"
                :permission="permCommandes.maj"
                :actions="actionSecondaryCommandePartiellement"
                :disabled="disableButtonCommande"
                @click="openCommandePartielle()">
                  {{ $t('detailDevis.actions.commandePartiellement') }}
              </dropdownButton>

              <button v-else-if="etatCommande && activeButtonEtLien"
                class="button is-addOrEdit "
                :class="{'button-access-no-permission' : !checkPermissions(permFactures.maj) }"
                @click="checkPermissions(permFactures.maj) ? inProgress() : showPopUp()">
                {{ $t('detail.buttons.acompte') }}
              </button>
            </b-tooltip>
              <verticalDotsDropdown
                class="is-relative mgb-2"
                :dropdownItems="dropdownItems"
                :permission="permCommandes.exporter"
                :isButton="true"/>
            <button class="button"
                    v-if="devis.etat !== constantes.ETAT_BROUILLON && activeButtonEtLien"
                    @click="openPopUpDuplicate = true">
              <b-icon icon="file-multiple" type="is-default"></b-icon>
            </button>
            <mail-button
              class="mgr-2"
              :perm="permDevis.lecture"
              :titlePopUp="'detailDevis.popUpMail.title'"
              :dcfDetail="detailDevis"
              :editionsAInclure="editionsAInclure"
              :mailSetUp="mailSetUp">
            </mail-button>
            <b-tooltip
              :active="!!isSignable.length"
              position="is-left">
              <template v-slot:content>
                <div v-for="(msg,i) in isSignable" :key="i">
                  <p>{{msg}}</p>
                </div>
              </template>
              <button class="button mgr-2"
                v-if="moduleSignatureElectroniqueActive  && activeButtonEtLien"
                :class="{ 'button-access-no-permission' : !checkPermissions(permDevis.maj)}"
                @click="checkPermissions(permDevis.maj)
                  ? popUpEnvoieDemandeSignature = true : showPopUp()"
                :disabled="!!isSignable.length">
                <b-icon
                  icon="signature-freehand"
                  type="is-default">
                </b-icon>
              </button>
            </b-tooltip>
            <b-tooltip
              :active="hasStopSignatureEnCours"
              :label="$t('detailDevis.stopSignature')"
              position="is-left">
              <button class="button mgr-2"
                v-if="activeButtonEtLien && hasStopSignatureEnCours"
                @click="closeDemandeSignature">
                <b-icon icon="hand-back-left-outline" type="is-default"></b-icon>
              </button>
            </b-tooltip>
            <button class="button"
                    @click="$refs.dropdownEdition.toggle()">
              <div>
                <b-icon icon="file-download" class="mgr-10px" type="is-default"></b-icon>
                <b-dropdown
                  ref="dropdownEdition"
                  position="is-bottom-left"
                  class="has-text-left">
                  <div slot="trigger">
                    <b-icon icon="chevron-down"
                            class="has-text-secondary-icon">
                    </b-icon>
                  </div>
                  <b-dropdown-item
                    @click="checkPermissions(permDevis.editer) ?
                    edition({format: constantes.pdf,
                      typeDonnee: constantes.typeEditionDevis}) : showPopUp()">
                    {{ $t('general.popUpEdition.type.pdf') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(permDevis.editer) ?
                    edition({format: constantes.docx,
                      typeDonnee: constantes.typeEditionDevis}) : showPopUp()">
                    {{ $t('general.popUpEdition.type.docx') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(permDevis.editer) ?
                    showPdfViewer = true : showPopUp()">
                    {{ $t('general.previsualisation') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(permDevis.editer) ?
                popUpEdition = true : showPopUp()">
                    {{ $t('general.popUpEdition.type.other') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </button>
            <piece-jointe-button
              v-if="devis.etat !== constantes.ETAT_BROUILLON && activeButtonEtLien"
              class="mgr-2"
              :perm="permDevis.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <error-msg-component :messages="messages"
                            :error="error"
                            :messagesChampsVide="messagesChampsVide"
                            :champsVide="champsVide"
                            :title="'general.problemOccurred'"
                            :withEmplyFields="true"
                            @close="error = $event"/>
      <div v-if="canSeeDevis && !activeButtonEtLien">
        <app-information-msg-component :title="'general.info'"
                                  :libelleList="[{ isLink: false,
                                  libelle: $t('detail.infos.devis') }]"
                                  :canClose="false">
        </app-information-msg-component>
      </div>
      <div class="tab" v-if="canSeeDevis">
        <ul>
          <li :class="{'is-active': activeTab === 'detailDevis'}"
              @click="activeTab = 'detailDevis'">
            {{ $t('detailDevis.tabs.detail') }}
          </li>
          <li :class="{ 'is-active': activeTab === 'detailAchatCommande' }"
              @click="activeTab = 'detailAchatCommande'"
              v-if="devis.role !== constantes.REGIE">
            {{ $t('detailDevis.tabs.achats') }}
          </li>
          <li :class="{'is-active': activeTab === 'logistique'}"
              @click="activeTab = 'logistique'">
            <b-field>
              <div class="mgv-auto mgr-5px round-circle-warning"
                   v-if="displayRoundAlerteLogistique"></div>
              <div class="mgr-5px" v-else></div>
              <span>{{ $t('detailDevis.tabs.logistique') }}</span>
            </b-field>
          </li>
          <li :class="{'is-active': activeTab === 'echeancierFacturation'}"
              @click="activeTab = 'echeancierFacturation'">
            {{ $t('detailDevis.tabs.echeancierFacturation') }}
          </li>
          <li :class="{'is-active': activeTab === 'previsualisation'}"
              @click="activeTab = 'previsualisation'">
            {{ $t('detailDevis.tabs.previsualisation') }}
          </li>
          <li :class="{'is-active': activeTab === 'etatSuiviDevisCommande'}"
              @click="activeTab = 'etatSuiviDevisCommande'" v-if="modulePresseActive">
            {{ $t('detailDevis.tabs.etatSuiviDevisCommande') }}
          </li>
          <li :class="{'is-active': activeTab === 'signatureElectroniqueHisto'}"
            @click="activeTab = 'signatureElectroniqueHisto'"
            v-if="moduleSignatureElectroniqueActive">
            {{ $t('detailDevis.tabs.signatureElectroniqueHisto') }}
          </li>
        </ul>
      </div>
      <div v-else>
        <app-information-msg-component :title="'general.info'"
                                       :libelleList="[{ isLink: false,
                                       libelle: $t('general.noAccess') }]"
                                       :canClose="false"
        >
        </app-information-msg-component>
      </div>
    </div>
    <component
      v-if="canSeeDevis"
      v-model="devis"
      :is="activeTab"
      :dcf="devis"
      :isEdit="false"
      :devisCommande="devis"
      :detailDevisCommande="detailDevis"
      :payeurSelected="payeurSelected"
      :commande="devis"
      :detailCommande="detailDevis"
      :isDevis="true"
      :toolTipSignatureInfo="toolTipSignatureInfo"/>
    <b-modal v-model="deleteCommand"
             has-modal-card
             class="modal">
      <confirmation-suppression-commande
        :devisCommandes="devisASupp"
        @rechargement="rechargementSuiteSuppression()"
        :type="typeDevis"/>
    </b-modal>
    <b-modal v-model="isCommandeOpen" v-if="devis"
             has-modal-card
             class="modal"
             width="45vw" >
      <app-confirmation-commande :devis="devis"/>
    </b-modal>
    <b-modal v-model="popUpAcompte" has-modal-card class="modal">
      <app-pop-up-acompte :devisCommande="detailDevis"
                          :type="devis.type"
      ></app-pop-up-acompte>
    </b-modal>
    <b-modal v-model="popUpSansSuite" has-modal-card class="modal">
      <app-pop-up-sans-suite
        :messHeader="$i18n.t('detail.popUpSansSuite.mess')"
        :cancel="$i18n.t('detail.popUpSansSuite.cancel')"
        :validate="$i18n.t('detail.popUpSansSuite.sansSuite')"
        :isErrorPopup.sync='isErrorPopup'
        :messagesPopup='messagesPopup'
        oncancel="popUpSansSuite = false"
        @no="popUpSansSuite = false"
        @yes="classerSansSuite()">
      </app-pop-up-sans-suite>
    </b-modal>
    <b-modal v-model="openPopUpDuplicate" has-modal-card class="modal">
      <pop-up-duplicate :title="$t('detailDevis.dupliquer.title', { code: devis.code }) "
                        :date="devis.datePremierAffichage"
                        @dupliquer="copy">
      </pop-up-duplicate>
    </b-modal>
    <b-modal v-model="popUpCommanderPartiellement" has-modal-card class="modal">
      <pop-up-commander-partiellement :lignes-commande="lignesForCommandePartiel"
                                      :devis-id="devis.id"
                                      :filtres="filtresCommanderPartiellement">
      </pop-up-commander-partiellement>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :choiceEdition="choiceEdition"
        :error="errorEdition"
        @editionChoose="edition"
      >
      </pop-up-edition>
    </b-modal>
    <b-modal v-model="popUpEnvoieDemandeSignature" has-modal-card class="modal">
      <pop-up-envoie-demande-signature
        :devisCommande="devis">
      </pop-up-envoie-demande-signature>
    </b-modal>
    <transition
      name="custom-classes-transition"
      enter-active-class="animate__animated animate__slideInRight"
      leave-active-class="animate__animated animate__slideOutRight"
      :duration="900">
      <pdf-viewer
        v-if="showPdfViewer"
        :payload-edition="{
          ids: [devis.id],
          typeDonnee: constantes.typeEditionDevis,
        }"
        @closed="showPdfViewer = false"
      />
    </transition>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import dropdownButton from '@/components/general/button/dropdownButton';
import AppBreadcrumb from '@/components/general/breadcrumb';
import confirmationSuppressionCommande from '@/components/devisCommandes/confirmationSuppressionCommande';
import confirmationCommande from '@/components/devisCommandes/confirmationCommande';
import popUpAcompte from '@/components/devisCommandes/detailDevisCommande/popUpAcompte';
import AppPopUpSansSuite from '@/components/general/popUpPrevention';
import { DEVIS, COMMANDES, FACTURES } from '@/configuration/permissionsBodacConf';
import detailDevisCommande from '@/services/devisCommandes/detailDevisCommande';
import { get, sansSuite } from '@/api/devis/index';
import { get as getPlanMedia } from '@/api/planMedia';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import {
  ETAT_ENREGISTRE,
  ETAT_COMMANDE,
  TYPE_EDITION_DEVIS,
  TYPE_EDITION_DEVIS_MAIL,
  TYPE_DEVIS,
  ETAT_COMMANDE_PARTIELLEMENT,
  LISTE_CHOICE_EDITION_DEVIS,
  ETAT_BROUILLON,
  EXPORT_EXCEL_LIGNE_DEVIS,
} from '@/configuration/devisConf';
import inProgress from '@/services/general/inProgress';
import genererCopyDevisCommande from '@/services/devisCommandes/genererCopyDevisCommande';
import edition from '@/api/edition/index';
import validationSansSuite from '@/services/devisCommandes/validation/validationSansSuite';
import detailDevis from '@/components/devisCommandes/detailDevisCommande/detailDevis';
import { CATEGORIE_UNITAIRE } from '@/configuration/catalogue/produitConf';
import { SET_COMMANDE } from '@/store/modules/commande-mutation-type';
import previsualisation
  from '@/components/devisCommandeFacture/previsualisation/previsualisation';
import { COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import { TYPE_DOCX, TYPE_PDF } from '@/configuration/edition/editionConf';
import getLignesCommandeForCommandePartielle from '@/services/bodac/devis/getLignesCommandeForCommandePartielle';
import getDateMinMaxLignesCommande from '@/services/bodac/devis/getDateMinMaxLignesCommande';
import popUpCommanderPartiellement from '@/components/bodac/devis/detailDevis/popUpCommanderPartiellement/p_commanderPartiellement';
import { REGIE } from '@/configuration/societe/societe';
import detailAchatCommande from '@/components/devisCommandes/achat/detailAchatCommande';
import popUpEdition from '@/components/factures/p_edition';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/devisCommandes/validation/champsFactureTranslator';
import popUpDuplicate from '@/components/commande/detail/p_duplicate';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import cloneDeep from 'lodash/cloneDeep';
import logistique from '@/components/commande/logistique/logistiqueOngletDetail';
import etatSuiviDevisCommande from '@/components/devisCommandes/presse/etatSuiviDevisCommande/etatSuiviDevisCommande';
import moment from 'moment';
import multiActionLogistiqueGetter from '@/services/logistique/demandeLogistique/multiActionLogistiqueGetter';
import echeancierFacturation from '@/components/devisCommandes/detailDevisCommande/echeancierFacturation';
import mailButton from '@/components/general/button/mailButton';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import signatureElectroniqueHisto from '@/components/devisCommandes/detailDevisCommande/signatureElectroniqueHisto';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAll as getAllSignatures, stopActionSignature } from '@/api/signatureElectronique';
import getInfosSignaturePourDevisCommande from '@/services/signatureElectronique/getInfosSignaturePourDevisCommande';
import { OPENNED } from '@/configuration/signatureElectronique/signatureElectroniqueConf';
import checkSiDevisSignable from '@/services/devisCommandes/signatureElectronique/checkSiDevisSignable';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import popUpEnvoieDemandeSignature from '@/components/devisCommandes/detailDevisCommande/popUpEnvoieDemandeSignature';
import exportExcel from '@/api/exportExcel';
import pdfViewer from '@/components/general/pdfViewer';
import verticalDotsDropdown from '@/components/general/button/verticalDotsDropdown';
import tagList from '@/components/general/tagList';

const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');
const Commandes = createNamespacedHelpers('commande');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      permDevis: DEVIS,
      permCommandes: COMMANDES,
      permFactures: FACTURES,
      detailDevis: null,
      devis: null,
      isCommandeOpen: false,
      payeurSelected: [],
      deleteCommand: false,
      devisASupp: [],
      typeDevis: TYPE_DEVIS,
      isErrorPopup: false,
      messagesPopup: [],
      popUpSansSuite: false,
      popUpAcompte: false,
      popUpEdition: false,
      activeTab: 'detailDevis',
      popUpCommanderPartiellement: false,
      filtresCommanderPartiellement: {
        periode: null,
        typeProduit: null,
      },
      lignesForCommandePartiel: [],
      constantes: {
        REGIE,
        pdf: TYPE_PDF,
        docx: TYPE_DOCX,
        typeEditionDevis: TYPE_EDITION_DEVIS,
        ETAT_BROUILLON,
        EXPORT_EXCEL_LIGNE_DEVIS: EXPORT_EXCEL_LIGNE_DEVIS,
      },
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      openPopUpDuplicate: false,
      editionsAInclure: [{
        libelle: 'detailDevis.popUpMail.inclureDevis', key: 'mettreEdition', value: true, type: TYPE_EDITION_DEVIS_MAIL,
      }],
      toolTipSignatureInfo: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      popUpEnvoieDemandeSignature: false,
      showPdfViewer: false,
      hasProspect: false,
    };
  },
  components: {
    tagList,
    appBreadcrumb: AppBreadcrumb,
    dropdownButton,
    confirmationSuppressionCommande,
    appConfirmationCommande: confirmationCommande,
    appPopUpAcompte: popUpAcompte,
    AppPopUpSansSuite,
    detailDevis,
    previsualisation,
    AppInformationMsgComponent,
    popUpCommanderPartiellement,
    detailAchatCommande,
    popUpEdition,
    popUpDuplicate,
    logistique,
    echeancierFacturation,
    etatSuiviDevisCommande,
    mailButton,
    pieceJointeButton,
    signatureElectroniqueHisto,
    errorMsgComponent,
    popUpEnvoieDemandeSignature,
    pdfViewer,
    verticalDotsDropdown,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...User.mapGetters({
      user: 'user',
      site: 'site',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societesInformations: 'societesInformations',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
    moduleSignatureElectroniqueActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.signatureElectronique.key);
    },
    moduleCBADiaporama() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.diaporamaCBA.key);
    },
    actionSecondary() {
      const actions = [];

      if (this.etatEnregistre) {
        actions.push(
          {
            label: this.$t('detail.buttons.sansSuite'),
            action: () => { this.popUpSansSuite = true; },
            permissionAction: DEVIS.maj,
          },
          {
            label: this.$t('detail.buttons.delete'),
            action: () => { this.deleteCommand = true; },
            permissionAction: DEVIS.supprimer,
          },
        );
      }

      return actions;
    },

    actionSecondaryCommande() {
      const actions = [
        {
          label: this.$t('detail.buttons.acompte'),
          action: () => { this.popUpAcompte = true; },
          permissionAction: FACTURES.maj,
          order: 2,
        },
      ];

      if (!this.disableButtonCommande) {
        actions.push(
          {
            label: this.$t('detailDevis.actions.commandePartiellement'),
            action: () => { this.openCommandePartielle(); },
            permissionAction: COMMANDES.maj,
            order: 1,
          },

        );
      }

      return actions;
    },

    actionSecondaryCommandePartiellement() {
      const actions = [
        {
          label: this.$t('detail.buttons.acompte'),
          action: () => { this.popUpAcompte = true; },
          permissionAction: FACTURES.maj,
        },
      ];

      return actions;
    },
    mailSetUp() {
      return {
        objet: this.$i18n.t('detailDevis.popUpMail.devisObject', {
          code: this.detailDevis.code,
          date: this.detailDevis.generalInfos.dateDevisCommande,
        }),
        contactDCFTitle: this.$t('detailDevis.popUpMail.contactTitle'),
      };
    },
    choiceEdition() {
      let typeEdition = cloneDeep(LISTE_CHOICE_EDITION_DEVIS);
      if (!this.moduleCBADiaporama) {
        typeEdition = typeEdition.filter(l => {
          return l.libelle !== 'catalogue.edition.diaporama';
        });
      }
      if (this.detailDevis.lignesCommande.some(l => {
        return l.typeProduit === CATEGORIE_UNITAIRE;
      })) {
        return typeEdition;
      }
      return typeEdition.filter(l => {
        return l.libelle !== 'detail.edition.devisDetailLc';
      });
    },
    canSeeDevis() {
      if (!this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key)) return true;
      return ((this.user.profil === COMMERCIAL
        && this.devis.commercialId === this.user.id)
        || this.user.profil !== COMMERCIAL);
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeDevis.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeDevis.title'), route: { name: 'l.bodac.devis' }, isActive: false },
        { title: this.$i18n.t('detail.titleDevis'), route: { name: 'c.bodac.devis' }, isActive: true },
      ];
      return output;
    },
    etatEnregistre() {
      return this.detailDevis.etat === ETAT_ENREGISTRE;
    },
    etatCommande() {
      return this.detailDevis.etat === ETAT_COMMANDE;
    },
    etatCommandePartiellement() {
      return this.detailDevis.etat === ETAT_COMMANDE_PARTIELLEMENT;
    },
    activeButtonEtLien() {
      return this.checkIfCurrentSociety(this.devis.societeId);
    },
    displayRoundAlerteLogistique() {
      return (this.devis.lignesCommande.some((ligne) => {
        return ((ligne.typeProduit === CATEGORIE_UNITAIRE
          && ligne.datePlanifieeLogistiqueAffichage
          && !moment(ligne.datePlanifieeLogistiqueAffichage).isSame(moment(ligne.dateDebut))
          || ligne.isAffecteLogistiquement)
        );
      })) || (this.detailDevis.lignesCommande.some((ligne) => {
        return multiActionLogistiqueGetter(ligne);
      }));
    },
    hasStopSignatureEnCours() {
      return this.moduleSignatureElectroniqueActive
        && this.devis.signaturesHisto
          .filter(el => el.contratEtatSignature === OPENNED).length === 1;
    },
    disableButtonCommande() {
      return this.moduleSignatureElectroniqueActive && this.devis.signaturesHisto.some(el => {
        return el.contratEtatSignature === OPENNED;
      });
    },
    desactivationControleSignatureSurVenteDevis() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS
        .desactivationControleSignatureSurVenteDevis.key);
    },
    isSignable() {
      const societe = this.societesInformations.find((s) => s.id === this.devis.societeId);
      return checkSiDevisSignable(this.devis, societe,
        this.desactivationControleSignatureSurVenteDevis);
    },
    exportExcelQuery() {
      return {
        typeDonnee: this.constantes.EXPORT_EXCEL_LIGNE_DEVIS,
        typeExport: null,
        filtres: {
          Query: this.lastPayload,
          sorting: 'ordre asc',
        },
      };
    },
    lastPayload() {
      return {
        ids: this.devis?.lignesCommande.flatMap(
          ligne => [ligne.id, ligne.lignesCommande.map(sousligne => sousligne.id)])
          .flatMap(id => id),
      };
    },
    dropdownItems() {
      return [{
        action: () => this.exporterLigneVente(),
        libelle: this.$t('detail.buttons.exporterLignesVentes'),
        id: 0,
      }];
    },
    devisTags() {
      if (!this.devis?.tags.length) return [];
      const tagIds = this.devis?.tags.map(t => t.tagId);
      return this.parametre(PARAMETRES_KEYS.tag).filter((t) => tagIds.includes(t.id));
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Commandes.mapMutations({
      setCommandeCourant: SET_COMMANDE,
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    openCommandePartielle() {
      this.lignesForCommandePartiel = getLignesCommandeForCommandePartielle(
        this.devis.lignesCommande,
      );
      if (!this.filtresCommanderPartiellement.periode) {
        this.filtresCommanderPartiellement.periode = getDateMinMaxLignesCommande(
          this.lignesForCommandePartiel,
        );
      }
      this.popUpCommanderPartiellement = true;
    },
    onNewPayeurSelected(index) {
      this.payeurSelected = this.detailDevis.payeurs[index];
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    async copy(newDateCmd) {
      this.setCommandeCourant(genererCopyDevisCommande(this.devis, newDateCmd));
      await this.$router.push({ name: 'm.bodac.devis-creation' });
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEdition.champsVide = [];
        this.errorEdition.messagesChampsVide = [];
        this.errorEdition.messages = [];
        this.errorEdition.haveError = false;
        if (!donnees.parametresAdditionnels) {
          donnees.parametresAdditionnels = {
            societeId: this.devis.societeId,
          };
        } else donnees.parametresAdditionnels.societeId = this.devis.societeId;
        const response = await edition({
          ids: [this.devis.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.popUpEdition = false;
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationDevisCommande({ data: response },
            this.errorEdition.messages,
            null,
            TYPE_DEVIS);
          validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
            this.errorEdition.messages, this.errorEdition.messagesChampsVide, translate);
          this.errorEdition.haveError = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async rechargementSuiteSuppression() {
      await this.$router.push({ name: 'l.bodac.devis' });
    },
    async classerSansSuite() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await sansSuite(this.devis.id);
        this.popUpSansSuite = false;
        await this.$router.push({
          name: 'c.bodac.devis-sansSuite',
          params: {
            id: this.devis.id,
            displayToastClasserSansSuite: true,
          },
        });
        return loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.isErrorPopup = true;
          validationSansSuite(e.response, this.messagesPopup, TYPE_DEVIS);
          return loadingComponent.close();
        }
        messageErreur(this.$i18n);
        return loadingComponent.close();
      }
    },
    async closeDemandeSignature() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.champsVide = [];
        this.messagesChampsVide = [];
        this.messages = [];
        this.error = false;
        await stopActionSignature(this.devis.id);
        loadingComponent.close();
        messageSucces(this.$t('detailDevis.messages.closeDemandeSignatureSucces'));
        this.$router.go(0);
        return;
      } catch (e) {
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async exporterLigneVente() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel(this.exportExcelQuery);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        if (this.errorManager) this.errorManager(e);
        else messageErreur(this.$i18n, this.$i18n.t('general.messages.error.excelError'));
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.displayToastClasserSansSuite) {
        messageSucces(this.$t('detail.validation.devisSansSuiteSuccess'));
      }
      await this.setAttachmentContext({ module: 'Devis' });
      await this.loadParametres([
        PARAMETRES_KEYS.categorieGroupeProduitDeductible,
        PARAMETRES_KEYS.regleFacturation,
        PARAMETRES_KEYS.materielType,
        PARAMETRES_KEYS.materielFormat,
        PARAMETRES_KEYS.dispositifSupport,
        PARAMETRES_KEYS.dispositifType,
        PARAMETRES_KEYS.tag,
      ]);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePresse.key,
        PARAMETRES_INTERNE_KEYS.signatureElectronique.key,
        PARAMETRES_INTERNE_KEYS.desactivationControleSignatureSurVenteDevis.key,
        PARAMETRES_INTERNE_KEYS.modulePlanMedia.key,
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
        PARAMETRES_INTERNE_KEYS.diaporamaCBA.key,
      ]);
      const devisCommande = (await get(this.$route.params.id)).data.result;
      devisCommande.etatSuivis.forEach((item) => {
        if (item.date) item.date = new Date(item.date);
      });
      if (devisCommande.dateTransmissionAuClub) {
        devisCommande.dateTransmissionAuClub = new Date(devisCommande.dateTransmissionAuClub);
      }
      if (devisCommande.dateTransmissionAuClient) {
        devisCommande.dateTransmissionAuClient = new Date(devisCommande.dateTransmissionAuClient);
      }
      this.devis = devisCommande;
      if (this.devis.planMediaId && this.modulePlanMediaActive) {
        this.devis.planMedia = (await getPlanMedia(this.devis.planMediaId)).data.result;
      }
      if (this.moduleSignatureElectroniqueActive) {
        this.devis.signaturesHisto = (await getAllSignatures({
          query: {
            referenceId: this.devis.id,
            societeId: this.societeActiveId,
          },
          MaxResultCount: NO_PAGINATION,
          SkipCount: 0,
        })).data.result.items;
        this.toolTipSignatureInfo = getInfosSignaturePourDevisCommande(this.devis.signaturesHisto);
      }
      await this.setAttachmentElementId({ id: this.devis.id });
      this.devisASupp.push(this.devis);
      this.detailDevis = detailDevisCommande(this.devis);
      this.payeurSelected = this.detailDevis.payeurs[0];
      loadingComponent.close();
      this.$bus.$on('new-payeur-selected', this.onNewPayeurSelected);
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.detailDevis.code }));
    this.hasProspect = this.devis.intervenants.some((intervenant) => intervenant.tiers.prospect);
  },
  destroyed() {
    this.$bus.$off('new-payeur-selected', this.onNewPayeurSelected);
  },
};
</script>
